import { render } from "./RADIO.vue?vue&type=template&id=47ae6eb0&scoped=true"
import script from "./RADIO.vue?vue&type=script&lang=js"
export * from "./RADIO.vue?vue&type=script&lang=js"

import "./RADIO.vue?vue&type=style&index=0&id=47ae6eb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ae6eb0"]])

export default __exports__